import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const WalletIcon = observer('WalletIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M19.5 6.83549H3.875V6.21049L17.625 5.11049V6.21049H19.5V4.33549C19.5 2.96049 18.3862 1.99549 17.0262 2.18924L4.475 3.98174C3.11375 4.17674 2 5.46049 2 6.83549V19.3355C2 20.7155 3.11875 21.8355 4.5 21.8355H19.5C20.88 21.8355 22 20.7155 22 19.3355V9.33549C22 7.95549 20.88 6.83549 19.5 6.83549ZM17.625 15.593C16.59 15.593 15.75 14.753 15.75 13.718C15.75 12.683 16.59 11.843 17.625 11.843C18.66 11.843 19.5 12.683 19.5 13.718C19.5 14.753 18.66 15.593 17.625 15.593Z'
                fill='fill'
            />
        </SvgElement>
    );
});
